import { motion } from 'framer-motion';
import { forwardRef, useState, type PropsWithChildren } from 'react';

export const RotatingButton = forwardRef<
  HTMLButtonElement,
  PropsWithChildren<{ onClick: () => void; disabled?: boolean }>
>(({ children, onClick, ...rest }, ref) => {
  const [rotation, setRotation] = useState(0);

  const handleClick = () => {
    onClick();
    setRotation(prev => prev + 180);
  };

  return (
    <motion.button
      ref={ref}
      onClick={handleClick}
      animate={{ rotate: rotation }}
      transition={{ duration: 0.4 }}
      className="bg-color-bg-primary z-10 col-span-full row-span-full flex size-10 rounded-full disabled:opacity-50"
      {...rest}
    >
      {children}
    </motion.button>
  );
});
